// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__30Enq","additionalInfo":"AgreementModal_additionalInfo__8PL0R"};